const firebaseConfig = {
  apiKey: "AIzaSyCs2PnVB4dv0QjRBXp_I5Sbk3NdX1kdmkQ",
  authDomain: "volunteer-network-client-a51f7.firebaseapp.com",
  databaseURL: "https://volunteer-network-client-a51f7.firebaseio.com",
  projectId: "volunteer-network-client-a51f7",
  storageBucket: "volunteer-network-client-a51f7.appspot.com",
  messagingSenderId: "588605357915",
  appId: "1:588605357915:web:9d7bfcc50f272d2ffaa47e"
};
export default firebaseConfig;